import React from 'react'
import Navbar from '../inc/Navbar';
import { Link } from "react-router-dom";

import ScrollToTop from "react-scroll-to-top";
import questdiagnostics from "../images/quest_diagnostics krishnagar.jpg";


function Aboutus() {
    return (
        <div>
            <Navbar />
            <br />
            <br />
            <br />
            <br />
            <ScrollToTop smooth top="100" color="light" />
            <div className='diagnostics'>
                <div className="album py-0 mt-3">
                    <div className="container">
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item"><Link to="/" style={{ color: "darkblue" }} href="#">Home</Link></li>

                                <li className="breadcrumb-item active" aria-current="page">About Us <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-chevron-double-right" viewBox="0 0 16 16">
                                    <path fill-rule="evenodd" d="M3.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L9.293 8 3.646 2.354a.5.5 0 0 1 0-.708" />
                                    <path fill-rule="evenodd" d="M7.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L13.293 8 7.646 2.354a.5.5 0 0 1 0-.708" />
                                </svg> </li>
                            </ol>
                        </nav>
                    </div>
                </div>
            </div>
            
            <div className='aboutus'>
                <br />
            <div className="album py-1">
                <div className="container">
                    <div className="row">
                        <div className="col-md-6 mt-3">
                            <div class="card-body">
                                <h3 style={{color:"#034b4c"}} className="card-title"><b>About Us </b>– Quest Diagnostics Krishnagar</h3>
                                <p style={{color:"#0a4546"}} className="abouttext card-text">Welcome to Quest Diagnostics Krishnagar – Nadia’s most trusted name in diagnostic excellence.</p>
                                <p style={{color:"#0a4546"}} className='abouttext'>Located in the heart of Krishnagar town, we are committed to delivering accurate, timely, and affordable medical testing services to our community. As part of the Quest Diagnostics network, our center brings global diagnostic standards to your neighborhood—with a strong focus on quality, care, and convenience.</p>
                              
                            </div>
                        </div>
                        <div className="col-md-6 mt-3">
                            <img src={questdiagnostics} className="card-img-top" alt="questdiagnostics"/>

                        </div>
                    </div>
                </div>

            </div>
            <br />
            <br />
</div>
        </div>
    )
}

export default Aboutus